module.exports = __webpack_public_path__ + "img/mouth.be5030ca.webp";